<!-- Navbar widget showing today's tracked time. Clicks open Analytics. -->
<template>
  <a
    v-if="store.hasAnalytics && !store.isFrontendOnly"
    :class="['today-trigger', isCompact ? 'today-trigger--compact' : 'navbar-item']"
    @click="openAnalytics"
  >
    <span v-if="hasActiveTimer" class="today-pulse"></span>
    <span class="today-lines">
      <span class="today-line-tracked">
        <strong>{{ trackedHours }}h {{ trackedMins }}m</strong>
        <span class="today-label">tracked</span>
      </span>
      <span v-if="showContext" class="today-line-context">
        {{ contextHours }}h {{ contextMins }}m in context
      </span>
    </span>
  </a>
</template>

<script setup>
import { computed, inject } from 'vue'
import { useBlocksStore } from '../stores/blocks'

const props = defineProps({
  variant: {
    type: String,
    default: 'default',
  },
})

const store = useBlocksStore()
const openAnalyticsPanel = inject('openAnalytics', null)
const isCompact = computed(() => props.variant === 'compact')

const trackedSeconds = computed(() => store.todayEventDuration)
const contextSeconds = computed(() => store.todayContextDuration)
const showContext = computed(() => contextSeconds.value > 0)
const hasActiveTimer = computed(() => !!store.activeTimer)

const trackedHours = computed(() => Math.floor(trackedSeconds.value / 3600))
const trackedMins = computed(() => Math.floor((trackedSeconds.value % 3600) / 60))
const contextHours = computed(() => Math.floor(contextSeconds.value / 3600))
const contextMins = computed(() => Math.floor((contextSeconds.value % 3600) / 60))

function openAnalytics() {
  if (openAnalyticsPanel) openAnalyticsPanel()
}
</script>

<style scoped>
.today-trigger {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.today-trigger--compact {
  align-self: stretch;
  border-radius: 0;
  color: var(--bulma-text);
  flex-shrink: 0;
  padding: 0.75rem 0.9rem;
  text-decoration: none;
}

.today-trigger:hover {
  background: var(--bulma-scheme-main-bis);
}

.today-pulse {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #4a4fba;
  flex-shrink: 0;
  animation: today-pulse-anim 2s ease-in-out infinite;
}
@keyframes today-pulse-anim {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.85); }
}

.today-lines {
  display: inline-flex;
  flex-direction: column;
  line-height: 1.25;
  text-align: left;
  white-space: nowrap;
}
.today-line-tracked {
  font-size: 0.72rem;
  font-variant-numeric: tabular-nums;
  color: var(--bulma-text);
}

.today-trigger--compact .today-line-tracked {
  font-size: 0.78rem;
}

.today-trigger--compact .today-line-context {
  font-size: 0.68rem;
}

.today-line-tracked strong {
  font-weight: 700;
}
.today-label {
  color: var(--bulma-text-weak);
  margin-left: 0.15rem;
}
.today-line-context {
  font-size: 0.65rem;
  font-variant-numeric: tabular-nums;
  color: #d5632d;
}
</style>
